import React from 'react';
import PropTypes from 'prop-types';
import ActionPanel from '../../../components/Controller/ActionPanel';
import PopupOverlay from '../../../components/common/PopupOverlay';
import ButtonPrimary from '../../../components/common/ButtonPrimary';

const AlertBox = ({ alertInfo, closeAlertDialogBox }) => {
  return (
    <PopupOverlay isOpen={alertInfo.isOpen} style={{ zIndex: 99999999999 }}>
      <div className="type-selector_box">
        <ActionPanel
          isCloseButtonHidden={false}
          onCloseButtonClick={() => {
            alertInfo.onDisagree();
            closeAlertDialogBox();
          }}
        >
          <div className="alert-box" style={{ zIndex: 99999 }}>
            <h1 className="alert-box_title">{alertInfo.title}</h1>
            <div className="alert-box_desc">{alertInfo.message}</div>
            <div className="alert-box_buttons">
              {alertInfo.isDisagreeAvailable && (
                <ButtonPrimary
                  onClick={() => {
                    alertInfo.onDisagree();
                    closeAlertDialogBox();
                  }}
                  label={alertInfo.disagreeButtonText}
                />
              )}
              <ButtonPrimary
                onClick={() => {
                  alertInfo.onAgree();
                  closeAlertDialogBox();
                }}
                label={alertInfo.agreeButtonText}
              />
            </div>
          </div>
        </ActionPanel>
      </div>
    </PopupOverlay>
  );
};

AlertBox.propTypes = {
  alertInfo: PropTypes.object,
  closeAlertDialogBox: PropTypes.func
};

export default AlertBox;
